module.exports = __webpack_public_path__ + "vue-dist/img/bind-card-failed.dc597862.png";